import { createContext } from "react";
import { contextFunctionInit } from "sprint-common-web";

export interface INavigationContext {
    isNavigationOpen: boolean;
    toggleNavigation: () => void;
}

export const NavigationContext = createContext<INavigationContext>({
    isNavigationOpen: true,
    toggleNavigation: contextFunctionInit
});
